
import styled from "styled-components";
import NavBar from "../../components/NavBar";
export default function Help() {

  return (
    <Wrapper>
      <NavBar title={"Help"} />
      <Container>
        <div className="text-center">
          <img style={{ width: "60%" }} src="/image/help1.png" alt="" />
        </div>

        <T>Runbit DAO Economic model</T>
        <ST>Token code of runbit DAO:RT</ST>
        <P>
          <ul>
            <li>The economic model is simply summarized as destruction - personal coinage - growth, that is, DPCG model (decentralized coinage). This model is an advanced model created by RB.</li>
            <li><span>Destruction: </span>transfer the right of the project party to issue coins (coinage right) to individuals, and the tokens used by users to purchase equipment and attribute cards will be 100% destroyed;</li>
            <li><span>Personal coinage: </span>all tokens in the project are minted by individuals, and the right to coin is fully released to individuals. All tokens are minted by players through sports, adding liquidity, community construction and other means. If individuals do not generate data, there will be no new coins;</li>
            <li><span>Growth: </span>that is, the growth of value. Because the way of personal coinage will not produce indiscriminate coinage, it will not produce inflation if it is forged completely according to the contract rules, and the more equipment is purchased, the more it is destroyed, which will form continuous deflation, which will continue to push up the value of RT, and thus continue to increase the wealth of coin holders.</li>
            <li><span>Issue price: </span>RT issue price is 1 USD;</li>
            <li>The founding team received 8% of the coin production as a reward, and 2% entered the community fund for community operations;</li>
            <li><span>Deflation mechanism:</span>RB that consumes and purchases equipment in the game will be 100% destroyed, unlimited destruction, extreme deflation. Due to its deflationary nature, the value of tokens will become higher and higher, thus continuously increasing the wealth of the holders;</li>
            <li><span>Liquidity pool: </span>RT can be cast through liquidity mining. The maximum daily output is dynamically adjusted with the circulation of tokens, and the daily output is about 1/180 of the number of tokens in the liquidity pool.</li>
            <li>The initial capital pool is constructed by the community subscribing 150000 RT in the early stage plus 10million RT in the listed value fund to provide early liquidity, and the segmented liquidity technology mechanism is adopted, which greatly improves the utilization rate of funds, promotes the stable rise of currency prices, and avoids currency price shocks caused by speculation. The 10million RT preset by the market capitalization fund will be 100% locked in the smart contract and will be permanently locked.</li>
          </ul>
        </P>

        <T>Rules of the Runbit DAO</T>
        <ST>
        Users unlock the card slot by purchasing sports equipment, and obtain attributes by purchasing attribute cards. With attributes, they can count their steps by walking and running to cast RT.
        </ST>
        <div style={{ marginBottom: "3.0rem" }}>
          <img src="/image/help2.png" alt="" style={{ width: "100%" }} />
        </div>
        <P>
          <ul>
            <li>
            The equipment needs to insert attribute cards to earn running income. Each equipment has three attribute card slots, and up to three attribute cards can be added
            </li>
            <li>Each kind of equipment has three levels in total, and low-level equipment cannot be installed with high-level attribute cards</li>
            <li>
            Users can buy level 1-level 3 equipment, and the price of level 1 equipment is between 1RT-5RT according to its rarity
            </li>
            <li>Equipment of the same level can be synthesized into equipment of higher level, and the synthesis costs 2RT</li>
            <li>
            Users need to complete 5000 steps to get full benefits. For every 500 steps less, the benefits will be reduced by 10%, and at least 40% of the benefits will be obtained
            </li>
            <li>
            Users can have multiple sets of the same equipment, and the steps of each set of equipment will be counted separately
            </li>
          </ul>
        </P>
        <div style={{ marginBottom: "2.1rem", marginTop: "3.0rem" }}>
          <img src="/image/help3.png" alt="" style={{ width: "100%" }} />
        </div>

        <Table>
          <tbody>
            <tr>
              <td></td>
              <td>APY</td>
              <td>Durability</td>
              <td>Price</td>
            </tr>
            <tr>
              <td>LV1</td>
              <td>110%</td>
              <td>70Days</td>
              <td>200 RT</td>
            </tr>
            <tr>
              <td>LV2</td>
              <td>140%</td>
              <td>90Days</td>
              <td>500 RT</td>
            </tr>
            <tr>
              <td>LV3</td>
              <td>168%</td>
              <td>110Days</td>
              <td>1500 RT</td>
            </tr>
          </tbody>
        </Table>
        <Table style={{ marginTop: "1.4rem" }}>
          <tbody>
            <tr>
              <td></td>
              <td>Specialty</td>
              <td>Aesthetic</td>
              <td>Comfort</td>
            </tr>
            <tr>
              <td>Drop rewards</td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.6rem" }}
                  src="/image/help_check.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td>Exemption from race track congestion losses</td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.6rem" }}
                  src="/image/help_check.png"
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td>Foundation casting / Day</td>
              <td>0.0001 RT</td>
              <td>0.00008 RT</td>
              <td>0.00008 RT</td>
            </tr>
          </tbody>
        </Table>
        <P>
          <ul>
            <li>The attribute card has three levels, and the casting efficiency of different levels is different;</li>
            <li>The attribute card has four attributes: Specialty comfort aesthetic durability;</li>
            <li>Attribute card will be launched by series, and the price and value of attribute card of different series are not fixed;</li>
            <li>100 durability value can be mined for 1 day;</li>
            <li>Aesthetics has a certain probability of equipment falling;</li>
            <li>Comfort can reduce the loss caused by track congestion;</li>
          </ul>
        </P>
        <div style={{ marginBottom: "2.1rem", marginTop: "3.0rem" }}>
          <img src="/image/help4.png" alt="" style={{ width: "100%" }} />
        </div>
        <Table>
          <tbody>
            <tr>
              <td>Equipment</td>
              <td>Gravel road</td>
              <td>Fragrant grassland</td>
              <td>Scorching sunbeach</td>
            </tr>
            <tr>
              <td>shoes</td>
              <td>100%</td>
              <td>90%</td>
              <td>90%</td>
            </tr>
            <tr>
              <td>trousers</td>
              <td>90%</td>
              <td>100%</td>
              <td>90%</td>
            </tr>
            <tr>
              <td>jacket</td>
              <td>90%</td>
              <td>90%</td>
              <td>100%</td>
            </tr>
          </tbody>
        </Table>
        <P style={{ marginTop: "2.0rem" }}>
          <ul>
            <li>
            There are three kinds of runways in the game: Gravel road, Fragrant grassland and Scorching sun beach. Gravel road needs shoes to run, Fragrant grassland needs pants to run, and Scorching sun beach needs a coat to run.
            </li>
            <li>
            Users can choose the runway to run, and the revenue of all equipment is calculated according to the selected runway. Choose one day in advance. If the runway does not match the assembly, its revenue will be reduced by 10%.
            </li>
            <li>
            An n-level attribute card with a capacity of n. When the runway is overloaded, the user's revenue will decline. When the runway exceeds the capacity of 10000 every day, the revenue will decline by 1% for every 1000, and at most 40%. The benefit of the comfort value of the attribute card is not affected.
            </li>
          </ul>
        </P>
        
        <T>
          Runbit DAO
          <br />
          Game community construction rewards
        </T>
        <div
          style={{
            marginBottom: "2.1rem",
            marginTop: "3.0rem",
            overflow: "auto",
          }}
        >
          <img style={{ width: "73.0rem" }} src="/image/help5.png" alt="" />
        </div>
        <P>
          <ul>
            <li>
            Every 100 durability (1 day) consumed by the attribute card can generate 1 activity, and each user can generate 1 activity at most every day
            </li>
            <li>
            Do not receive dividends repeatedly after upgrading; In the assessment after upgrading, the increase of team activity per week shall not be less than 4%. If the team fails to meet the standard in the first week, it will be rewarded with 70% bonus; if the team fails to meet the standard in the second week, it will be rewarded with 50% bonus; if the team fails to meet the standard in the third week, it will be rewarded with 40% bonus. In the fourth week, the proportion of non-compliance will not decrease. In the future, as long as there is one week to meet the standard, you can pay dividends normally.
            </li>
            <li>The recommender must purchase the attribute card before he can get all rewards.</li>
          </ul>
        </P>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-image: linear-gradient(#fdf8c4 1%, #f9f9f9 9%);
`;
const Container = styled.div`
  padding: 0 2.0rem 3.6rem;

  * {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.0rem;
    color: #969696;
    line-height: 2.0rem;
  }
`;
const T = styled.div`
  font-weight: 600;
  font-size: 2.6rem;
  line-height: 1.3;
  letter-spacing: 0.05em;
  color: #000000;
  text-align: center;
  margin-top: 5.8rem;
`;

const ST = styled.div`
  letter-spacing: 0.2em;
  color: #4a4a4a;
  text-align: center;
  margin: 1.5rem 0 1.6rem;
`;

const P = styled.div`
  span {
    color: #000000;
  }
  ul {
    padding-left: 1.0rem;
    li {
      list-style: disc;
    }
  }
`;

const Table = styled.table`
  width: 100%;
  background: linear-gradient(180deg, #f1f1f1 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: .8rem;
  text-align: center;
  border-collapse: collapse;

  td {
    padding: 1.4rem 0;
    font-size: 1.3rem;
    border-bottom: 1px solid #bdbdbd;
    color: #000;
  }
  tr:last-child td {
    border-bottom: none;
  }
`;
